import styled from "@emotion/styled";
import { Modal, modalClasses } from "@kaltura/ds-react-components";

export const StyledCreateRoomModal = styled(Modal)(({ theme }) => ({
    [`& .${modalClasses.paper}`]: {
        minWidth: 664,
        maxWidth: 664,
        maxHeight: "70vh",
        [theme.breakpoints.down(theme.breakpoints.values.md)]: {
            minWidth: 520,
            maxWidth: 520,
        },
        [theme.breakpoints.down(theme.breakpoints.values.sm)]: {
            minWidth: "100%",
            maxWidth: "100%",
            maxHeight: "100vh",
        },
    },
}));
